import { experiencesService } from '@/services/experiences.service.js';

const state = {
  listOutput: null,
  getExperienceByIdOutput: null,
  getExperienceBySlugOutput: null
};

const mutations = {
  setListOutput(state, payload) {
    state.listOutput = payload;
  },
  setGetExperienceByIdOutput(state, payload) {
    state.getExperienceByIdOutput = payload;
  },
  setGetExperienceBySlugOutput(state, payload) {
    state.getExperienceBySlugOutput = payload;
  }
};

const actions = {
  async getList({ commit }, input) {
    try {
      const response = await experiencesService.getList(input);
      commit('setListOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching experiences list:', error);
      throw error;
    }
  },
  
  async getById({ commit }, id) {
    try {
      // Clear slug-based cache to avoid leaking previous details
      commit('setGetExperienceBySlugOutput', null);
      const response = await experiencesService.getById(id);
      commit('setGetExperienceByIdOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching experience by id:', error);
      throw error;
    }
  },
  
  async getBySlug({ commit }, slug) {
    try {
      // Clear id-based cache to avoid mixing objects between pages
      commit('setGetExperienceByIdOutput', null);
      const response = await experiencesService.getBySlug(slug);
      // Keep full response; getter reads .data
      commit('setGetExperienceBySlugOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching experience by slug:', error);
      throw error;
    }
  }
};

const getters = {
  experiences: state => state.listOutput?.data || [],
  experience: state => state.getExperienceBySlugOutput?.data || state.getExperienceByIdOutput?.data || null
};

export const experiences = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

